type File = {
  url: string
}
export type AdditionalInformation = {
  title: string;
  text?: string;
  links?: Record<string, unknown>[];
  files?: Record<string, unknown>[];
};

export type Department = {
  id: number;
  title: string;
};

export type Requirement = {
  title: string;
  requirementId: number;
  answers: AnswerQuestion[];
  isFocal?: boolean;
  documentation?: AdditionalInformation;
  actions?: string[];
  comments?: string[];
};

export type Block = {
  title: string;
  groupRequirements: Requirement[];
};

export type DirectionsRequirement = {
  title: string;
  quarters: ItemRowSummary[]
};

export type RequirementDirection = {
  year: string;
  quarter: string;
  factory: string;
  title: string;
  direction: ItemRowFactor;
  completedAssessment?: string;
  completionDate?: string;
};

export type ItemRowFactor = {
  title: string,
  blockRequirements: Block[];
}

export type ItemRowSummary = {
  quarter: Quarter,
  blockRequirements: Block[];
}

export type AnswerOption = 'Да' | 'Нет' | 'N/A';

export type AnswerQuestion = {
  answerId: number | null;
  department: string;
  departmentId: number;
  answer: AnswerOption;
  isEdit: boolean;
};

export type Settings = {
  UsersGroup: any;
  id: number;
  title: string;
  description: string;
  url: string;
  icon: File;
}

export type Quarter = 'Q1' | 'Q2' | 'Q3' | 'Q4';

export type UniversalObject = { [key: string]: string | number };

export type StatusQuestionnaire = 'Не начато' | 'В процессе' | 'Завершено';

export enum QuarterDictionary {
  Q1 = 'I',
  Q2 = 'II',
  Q3 = 'III',
  Q4 = 'IV'
}
